import ErrorBoundary from "components/Error/errorBoundary";
import React, {useState} from "react";
import {QUOTE} from "v4/data/entities";
import {usePolTranslation} from "v4/hooks/usePolTranslation";
import ListingEntityLayout from "v4/layouts/ListingEntityLayout/ListingEntityLayout";
import ListingHeaderEntityLayout from "v4/layouts/ListingHeaderEntityLayout/ListingHeaderEntityLayout";
import QuotesListingRowActions
    from "v4/pages/front/Quotes/components/QuotesListing/components/QuotesListingRowActions/QuotesListingRowActions";
import QuotesListingTools
    from "v4/pages/front/Quotes/components/QuotesListing/components/QuotesListingTools/QuotesListingTools";

import { useSearchContext } from "v4/contexts/SearchContext/SearchContext";

export default function QuotesListing() {
    const { tab } = useSearchContext();
    const {t} = usePolTranslation();
    const [totalItems, setTotalItems] = useState(null);

    return (
        <>
            <div className="page-list__content">
                 <div className="table-container">
                    <ErrorBoundary>
                        <ListingHeaderEntityLayout totalItems={totalItems}
                                                   title={tab?.label ?? t('devis_offres')}
                                                   pageType='devis'
                                                   resultsText={
                                                       t('resultats_elements_devis', {count: totalItems})
                                                   }/>
                    </ErrorBoundary>
                    <ErrorBoundary>
                        <ListingEntityLayout entity={QUOTE}
                                             toolsRender={({checkedRows}) => <QuotesListingTools checkedRows={checkedRows}/>}
                                             rowActions={<QuotesListingRowActions />}
                                             tableClassName="devis"
                                             setTotalItems={setTotalItems} />
                    </ErrorBoundary>
                </div>
            </div>
        </>
    )
}
